import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-confirmation-dialog',
  templateUrl: './warning-confirmation-dialog.component.html',
  styleUrl: './warning-confirmation-dialog.component.scss'
})
export class WarningConfirmationDialogComponent {

  constructor(private _dialogRef: MatDialogRef<WarningConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDdialogData
  ) {
    
  }


}

export interface IDdialogData{
title: string;
line1: string;
line2: string;
submitButton: string;
}